import { useDispatch, useSelector } from "react-redux";
import { useInProgress } from "../../base";
import { constants } from "../index";

import {
  getAccountsReceivableForDate,
  searchInvoicesByDate,
} from "../store/actions";

export const useSearchInvoices = ({ fromDate, toDate, creditorId }) => {
  const dispatch = useDispatch();
  const storeName = constants.STORE_NAME;

  if (!fromDate || !toDate || !creditorId)
    throw Error("creditorId or dates missing");

  const processName = `${fromDate}-${toDate}`;

  const matchingSearchInvoices = useSelector(
    (state) => state[storeName][processName]
  );

  const inProgress = useInProgress({ storeName, name: processName });

  if (inProgress) return [undefined, true];

  // check if current search is the one we want, if not, we fetch it
  if (!matchingSearchInvoices) {
    dispatch(
      searchInvoicesByDate({
        creditorId,
        fromDate,
        toDate,
        processName,
      })
    );
    return [undefined, true];
  }

  return [matchingSearchInvoices, false];
};

export const useAccountsReceivableForDate = ({
  date,
  creditorId,
  excludeInvoicesWithPeriodOutsideDate,
}) => {
  const dispatch = useDispatch();
  const storeName = constants.STORE_NAME;

  if (!date || !creditorId) throw Error("creditorId or date missing");

  const processName = `${date}-${creditorId}`;

  const invoices = useSelector(
    (state) =>
      state[storeName][
        `${creditorId}-${date}-${excludeInvoicesWithPeriodOutsideDate}`
      ]
  );

  const inProgress = useInProgress({ storeName, name: processName });

  if (inProgress) return [undefined, true];

  // check if current search is the one we want, if not, we fetch it
  if (!invoices) {
    dispatch(
      getAccountsReceivableForDate({
        creditorId,
        date,
        processName,
        excludeInvoicesWithPeriodOutsideDate,
      })
    );
    return [undefined, true];
  }

  return [invoices, false];
};
